import { useState } from "react";
import { Header } from "@/components/layout/header";
import { Sidebar } from "@/components/layout/sidebar";
import { EnvironmentBanner } from "@/components/layout/environment-banner";
import { ErrorBoundary } from "@/components/shared/error-boundary";
import { isNonProduction } from "@/lib/environment";

interface AppShellProps {
  children: React.ReactNode;
}

export function AppShell({ children }: AppShellProps) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const bannerHeight = isNonProduction() ? "1.75rem" : "0px";

  return (
    <div
      className="flex min-h-screen flex-col"
      style={{ "--env-banner-h": bannerHeight } as React.CSSProperties}
    >
      <div className="print:hidden">
        <EnvironmentBanner />
      </div>

      <div className="flex flex-1">
        <div className="print:hidden">
          <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        </div>

        <div className="flex min-w-0 flex-1 flex-col">
          <div className="print:hidden">
            <Header onMenuToggle={() => setSidebarOpen((prev) => !prev)} />
          </div>

          <main className="min-w-0 flex-1 p-4 lg:p-6 print:p-0">
            <ErrorBoundary>{children}</ErrorBoundary>
          </main>
        </div>
      </div>
    </div>
  );
}
